import React from 'react';
import {AlertContext} from './controlAlert';
import moment from "moment";
import './Alert.css';

class Alert extends React.Component {

    cancelApp = () => {

    }

    hidePopup = () => {

    }

    render() {
       /*  if (this.props.appState.errorData && this.props.appState.errorData.errorHandlingAction == ErrorDataHandlingAction.ShowPopup){ */
            return(
                <AlertContext.Consumer> 
                    { state => {
                        console.log(state);
                        if(state.showAlert === 1) {
                            return (
                                <div id="myModal" className="hc-modal-overlay">
                                    <div className="hc-modal-card hc-modal-card--info">
                                    <div className="hc-modal-icon"><i className="icofont-clock-time"></i></div>
                                    <div>
                                        <p>Bạn đã có lịch đặt vào thời gian:</p>
                                        <p className='alert_font success-content'>  {state.appoint_time}  </p>
                                    </div>
                                    <div className="hc-modal-actions">
                                        <button type="button" className="button no btn-no" onClick={state.deleteAppointment}>Hủy lịch</button>
                                        <button type="button" className="button yes btn-yes" onClick={state.toggleAlert}>Thoát</button>
                                    </div>
                                    </div>
                                </div>

                            );}
                        else if(state.showAlert === 2) {
                            return (
                                <div id="myModal" className="hc-modal-overlay">
                                    <div className="hc-modal-card hc-modal-card--success">
                                    <div className="hc-modal-icon"><i className="icofont-check-circled"></i></div>
                                    <div>
                                        <p>Bạn đã hủy lịch thành công</p>
                                    </div>
                                    <div className="hc-modal-actions">
                                        <button type="button" className="button yes btn-yes" onClick={state.toggleAlert}>Thoát</button>
                                    </div>
                                    </div>
                                </div>
                            );
                        }
                        else if(state.showAlert === 3) {
                            return (
                                <div id="myModal" className="hc-modal-overlay">
                                    <div className="hc-modal-card hc-modal-card--warn">
                                    <div className="hc-modal-icon"><i className="icofont-info-circle"></i></div>
                                    <div>
                                        <p> Bạn chưa có lịch đặt nào </p>
                                    </div>
                                    <div className="hc-modal-actions">
                                        <button type="button" className="button yes btn-yes" onClick={state.toggleAlert}>Thoát</button>
                                    </div>
                                    </div>
                                </div>
                            );
                        }
                        else if(state.showAlert === 4) {
                            return (
                                <div id="myModal" className="hc-modal-overlay">
                                    <div className="hc-modal-card hc-modal-card--success">
                                    <div className="hc-modal-icon"><i className="icofont-check-circled"></i></div>
                                    <div>
                                        <p className="success-title"> ĐẶT LỊCH THÀNH CÔNG </p>
                                        <p> Tên khách hàng: <b className="success-content">{state.app_name}</b> </p>
                                        <p> Đặt lịch vào: <b className="success-content">{ state.app_date }</b> </p>
                                        <p> Giờ khám: <b className="success-content">{state.app_time} </b> </p>
                                        <p className="hc-modal-note"> *Chú ý: Nếu có mặt muộn sau giờ trên, lịch sẽ bị hủy, hãy vào báo lại tên và ngồi đợi để khám theo diện không đặt lịch </p>
                                    </div>
                                    <div className="hc-modal-actions">
                                        <button type="button" className="button yes btn-yes" onClick={state.toggleAlert}>Đồng ý</button>
                                    </div>
                                    </div>
                                </div>
                            );
                        }
                        else if(state.showAlert === 5) {
                            return (
                                <div id="myModal" className="hc-modal-overlay">
                                    <div className="hc-modal-card hc-modal-card--warn">
                                    <div className="hc-modal-icon"><i className="icofont-info-circle"></i></div>
                                    <div>
                                        <p> Không còn lịch trống nào vào ngày được chọn. Xin chọn ngày muốn đặt lịch khác </p>
                                    </div>
                                    <div className="hc-modal-actions">
                                        <button type="button" className="button yes btn-yes" onClick={state.toggleAlert}>Thoát</button>
                                    </div>
                                    </div>
                                </div>
                            );
                        }
                        /* alert('Đặt lịch thành công. \n' + 
                        'Tên khách hàng: '+ this.state.k1_name +
                        '\nĐặt lịch vào: '+ moment(this.state.timeslotSelectedDate).format('DD - MM - yyyy') +
                        '\nGiờ khám: '+ this.state.timeslotSelectedText +
                        '\nXin cám ơn quý khách'); */
                        else {
                            return null;
                        }
                }}
                </AlertContext.Consumer>
            )
       // }
        return null;
    }
}
export default Alert;